import styled from 'styled-components'
import { Grid } from 'components/grid'
import { AI } from 'components/feather'
import { aiGradientCss } from 'components/content-assistant/s'

export const LabelWithIcon = styled(Grid).attrs(attrs => ({
    ...attrs,
    as: 'span'
}))`
    grid-template-columns: min-content 1fr;
    gap: 16px;
`

export const AiIcon = styled(AI)`
    /* Aligning a 24px icon on a 20px row */
    margin-block: -2px;

    @media (prefers-reduced-motion: no-preference) {
        &:where(.selected) path {
            ${aiGradientCss}
        }
    }
`